import { useCallback } from "react";
import { useCreateClassMutation } from "../../../../api/class.api";
import { ClassForm, ClassSchema } from "./ClassForm";

export const CreateClassModal = ({
    parentClassId,
    onHide,
}: {
    onHide: () => void;
    parentClassId: string | null;
}) => {
    const createMutation = useCreateClassMutation();

    const onSubmit = useCallback(
        (classData: ClassSchema) =>
            createMutation.mutateAsync({
                label: classData.name,
                parentClassId,
            }),
        [createMutation, parentClassId],
    );

    return (
        <ClassForm
            onHide={onHide}
            onSubmitClass={onSubmit}
            isPending={createMutation.isPending}
            parentClassId={parentClassId}
        />
    );
};
